import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.005 31.509C7.442 31.509.5 24.567.5 16.005S7.442.5 16.005.5s15.504 6.942 15.504 15.505-6.942 15.504-15.504 15.504zm0-1.348c7.818 0 14.156-6.338 14.156-14.156S23.823 1.848 16.005 1.848 1.848 8.186 1.848 16.005 8.186 30.16 16.005 30.16zM13.16 11.089l5.242 5.243-5.244 5.243a.674.674 0 1 0 .954.954l5.72-5.721a.674.674 0 0 0 0-.953l-5.72-5.72a.674.674 0 1 0-.954.954h.002z"
    />
  </svg>
);

const IconCircleRight: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconCircleRight;
